import {
  Button,
  Dialog,
  Field,
  Input,
  Modal,
  Select,
  Spacer,
  Text,
} from '@oliasoft-open-source/react-ui-library';
import translations from 'client/internationalization/translation-map.json';
import { OwnerType } from 'common/enums/owner-enums';
import { IDashboard } from 'common/interfaces/analytics';
import { startCase } from 'es-toolkit';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type DashboardModalProps = {
  visible: boolean;
  onClose: () => void;
  itemForEdit: IDashboard | null;
  onSubmit: (dashboard: IDashboard) => void;
};

// Expect this table to extend with additional dashboard config
export const DashboardModal = ({
  visible,
  onClose,
  itemForEdit,
  onSubmit,
}: DashboardModalProps) => {
  const { t } = useTranslation();
  const [selectedDashboard, setSelectedDashboard] = useState<{
    dashboardid?: string;
    name: string;
    type: keyof typeof OwnerType;
  }>({
    dashboardid: '',
    name: '',
    type: OwnerType.USER,
  });

  const typeOptions = Object.values(OwnerType).map(value => ({ value, label: startCase(value) }));

  useEffect(() => {
    if (itemForEdit?.dashboardid) {
      setSelectedDashboard(itemForEdit);
    }
  }, [itemForEdit?.dashboardid]);

  const handleSubmit = () => {
    if (itemForEdit?.dashboardid) {
      const updatedDashboard = {
        ...itemForEdit,
        ...selectedDashboard,
      };
      onSubmit(updatedDashboard);
    } else {
      onSubmit({ name: selectedDashboard.name, type: selectedDashboard.type });
    }
  };

  const editDashboard = (event: React.ChangeEvent<{ value: string, name: string }>) => {
    const { target: { name, value } } = event;
    setSelectedDashboard({ ...selectedDashboard, [name]: value });
  };

  const selectedType = typeOptions.find(i => i?.value === selectedDashboard?.type);

  const content = (
    <>
      <Field>
        <Text bold>{t(translations.name)}</Text>
        <Spacer height="var(--padding-xxs)" />
        <Input
          name="name"
          value={selectedDashboard?.name}
          onChange={editDashboard}
        />
      </Field>
      <Field>
        <Select
          name="type"
          value={selectedType}
          options={typeOptions}
          onChange={editDashboard}
          placeholder={t(translations.analytic_dashboardSelect)}
        />
      </Field>
    </>
  );
  return (
    <Modal visible={visible} centered onEscape={onClose}>
      <Dialog
        dialog={{
          scroll: true,
          heading: t(translations.analytic_dashboards),
          content,
          footer: (
            <>
              <Button
                label={t(translations.save)}
                onClick={handleSubmit}
                disabled={!selectedDashboard.name || !selectedDashboard.type}
              />
              <Button label={t(translations.cancel)} onClick={onClose} />
            </>
          ),
          onClose,
          width: '30%',
        }}
      />
    </Modal>
  );
};